import {z} from '@hono/zod-openapi';

export const VoiceWebhookErrorResponseSchema = z
  .object({
    code: z.string().openapi({example: 'common-008'}),
    message: z.string().openapi({example: 'Invalid webhook body'}),
  })
  .strict()
  .openapi('VoiceWebhookErrorResponseSchema');
